import { AnnotatedNotitie, NOTE_COLORS } from './annotatedNotitieTypes';

export const MAX_NOTITIE_TEXT_LENGTH = 2000;
export const MAX_NOTITIE_MARKS = 50;

export type AnnotatedNotitieValidationError =
  | 'TEXT_TOO_LONG'
  | 'TOO_MANY_MARKS'
  | 'MARK_OUT_OF_BOUNDS'
  | 'MARK_EMPTY_RANGE'
  | 'UNKNOWN_COLOR'
  | 'UNKNOWN_MARK_TYPE';

export const validateAnnotatedNotitie = (notitie: AnnotatedNotitie): AnnotatedNotitieValidationError[] => {
  const errors = new Set<AnnotatedNotitieValidationError>();

  if (notitie.text.length > MAX_NOTITIE_TEXT_LENGTH) errors.add('TEXT_TOO_LONG');
  if (notitie.marks.length > MAX_NOTITIE_MARKS) errors.add('TOO_MANY_MARKS');

  for (const mark of notitie.marks) {
    if (!['BOLD', 'COLOR', 'PRIVATE'].includes(mark.type)) errors.add('UNKNOWN_MARK_TYPE');
    if (mark.start < 0 || mark.end > notitie.text.length) errors.add('MARK_OUT_OF_BOUNDS');
    if (mark.start >= mark.end) errors.add('MARK_EMPTY_RANGE');
    if (mark.type === 'COLOR' && !NOTE_COLORS.includes(mark.color)) errors.add('UNKNOWN_COLOR');
  }

  return [...errors];
};
